import ObjectDeleteError from '%paysera_seat_selection/js/seatSelection/redux/component/orm/errors/ObjectDeleteError';
import Translator from '%app/js/common/services/translator';
import { extractSeatsFromModel } from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/extractSeatsFromSelection';
import { SEAT_PURCHASE_STATUS_FREE } from '%paysera_seat_selection/js/seatSelection/config/constants';

function resolveSeatPath(seat) {
    const paths = [];
    if (seat.roundTable !== null) {
        paths.push(Translator.trans(
            'seat_selection.delete_error.seat_path.round_table',
            { name: seat.roundTable.label.text },
        ));
    }
    if (seat.rectangleTable !== null) {
        paths.push(Translator.trans(
            'seat_selection.delete_error.seat_path.rectangle_table',
            { name: seat.rectangleTable.label.text },
        ));
    }
    if (seat.row !== null) {
        paths.push(Translator.trans(
            'seat_selection.delete_error.seat_path.sector',
            { name: seat.row.sector.label.text },
        ));
        paths.push(Translator.trans(
            'seat_selection.delete_error.seat_path.row',
            { name: seat.row.labelLeft.text || seat.row.labelRight.text },
        ));
    }

    paths.push(Translator.trans(
        'seat_selection.delete_error.seat_path.seat',
        { name: seat.label.text },
    ));

    return paths.join(' , ');
}

function validateSeats(seats) {
    const nonFreeSeats = [];
    seats.forEach((seat) => {
        if (seat.purchaseStatus !== SEAT_PURCHASE_STATUS_FREE) {
            nonFreeSeats.push(resolveSeatPath(seat));
        }
    });

    if (nonFreeSeats.length > 0) {
        throw new ObjectDeleteError(nonFreeSeats);
    }
}

class ObjectDeletionValidator {
    validateGeneralAdmission(object) {
        if (object.seatsUsed > 0) {
            throw new ObjectDeleteError([
                Translator.trans(
                    'seat_selection.delete_error.general_admission',
                    { name: object.label.text },
                ),
            ]);
        }
    }

    validateRoundTable(object) {
        validateSeats(extractSeatsFromModel(object));
    }

    validateRow(object) {
        validateSeats(extractSeatsFromModel(object));
    }

    validateSector(object) {
        validateSeats(extractSeatsFromModel(object));
    }

    validateRectangleTable(object) {
        validateSeats(extractSeatsFromModel(object));
    }

    validateSeat(object) {
        validateSeats([object]);
    }
}

export default new ObjectDeletionValidator();
